/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 (function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        jQuery(".main h2").addClass("wow");
        jQuery(".video .entry-image, .row-circles .vc_grid-item:first-child, .row-circles .vc_grid-item:last-child").addClass("wow circleRotate");
        jQuery(".wpb_text_column p, .wpb_single_image").addClass("wow fadeIn");
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        function headerScroll() {
          if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            document.querySelector('body').classList.add('bg-white');
          } else {
            document.querySelector('body').classList.remove('bg-white');
          }
        }

        headerScroll();

        // Calls headerScroll function when user starts to scroll to change header bg colour.
        window.onscroll = function () {
          headerScroll();
        };

        function timelineSlickSettings() {
          return {
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            infinite: false,
            arrows: true,
            prevArrow: $('.timeline-slick-carousel-arrows .prev'),
            nextArrow: $('.timeline-slick-carousel-arrows .next'),
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: true,
                  dots: true
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          };
        }

        $('.timeline-slick-carousel').slick(timelineSlickSettings());

        /**
         * This just reads the inputs from the 
         * selects and creates the filter.
         */
        function getFilterValue() {
          // Grab all the values from the filters.
          var values = $('.timeline-filter-group').map(function() {
            // For each group, get the select values.
            var groupVal = $(this).find('select').map(function() {
              return $(this).val();
            }).get();
            // join the values together.
            return groupVal.join('');
          }).get();

          // Remove empty strings from the filter array.
          // and join together with a comma. this way you 
          // can use multiple filters.
          return values.filter(function(n) {
            return n !== "";
          }).join(',');
        }

        // When the filter values are changed, 
        // apply the filter to slick.
        $('form.timeline-filter select').on('change', function() {
          var filterClass = getFilterValue();
          // $('.filter-class').text(filterClass);

          if (filterClass === '.all') {
            $('.timeline-slick-carousel').slick('slickUnfilter');
          } else {
            $('.timeline-slick-carousel').slick('slickUnfilter');
            $('.timeline-slick-carousel').slick('slickFilter', filterClass);
          }
        });

        (function () {
          "use strict";
          function expandMenu() {

            jQuery('.menu-container .menu').show().animate({
              right:"0px"
            }, 300);
            jQuery('.wrap').animate({
              opacity: 0.3
            }, 300);
            jQuery('.footer').animate({
              opacity: 0.3
            }, 300);
            jQuery('.post-footer').animate({
              opacity: 0.3
            }, 300);
          }


          jQuery('.match-height, .recent-news').matchHeight();
          jQuery('.post-footer').css('padding-bottom',jQuery('.anchorlinks').height());
          function minimiseMenu() {
            jQuery('.menu-container .menu').animate({
              right:"-380px"
            }, 300, function() {
              jQuery('.menu-container .menu').hide();
            });
            jQuery('.wrap').animate({
              opacity: 1.0
            }, 300);
            jQuery('.footer').animate({
              opacity: 1.0
            }, 300);
            jQuery('.post-footer').animate({
              opacity: 1.0
            }, 300);
          }

          function toggleHandler(toggle) {
            toggle.addEventListener("click", function (e) {
              e.preventDefault();
              if (this.classList.contains("is-active") === true) {
                this.classList.remove("is-active");
                minimiseMenu();
              } else {
                this.classList.add("is-active");
                expandMenu();
              }
            });
          }

          var toggles = document.querySelectorAll(".c-hamburger");
          for (var i = toggles.length - 1; i >= 0; i--) {
            var toggle = toggles[i];
            toggleHandler(toggle);
          }

          $('.wrap').on('click', function(){
            if ($('.c-hamburger').hasClass("is-active") === true) {
              $('.c-hamburger').removeClass("is-active");
              minimiseMenu();
            }
          });


        })();



        jQuery('.ls-modal-open-btn').on('click', function() {
          var modalid = jQuery(this).data('modalid');
          jQuery('#ls-modal-'+modalid).fadeIn(200);
        });

        jQuery('.ls-modal-close-btn').on('click', function() {
          var modalid = jQuery(this).data('modalid');
          jQuery('#ls-modal-'+modalid).fadeOut(200);
        });




        jQuery('a[href*="#"]').not('[href="#"]').not('[href="#0"]').on('click', function(event) {
          if (
            (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')) && (location.hostname === this.hostname)
            ) {

                  // Figure out element to scroll to

                var target = jQuery(this.hash);

                target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');

                  // Does a scroll target exist?

                  if (target.length) {

                      // Only prevent default if animation is actually gonna happen
                      event.preventDefault();

                      var scrolloffset = target.offset().top - 200;

                      if (scrolloffset < 250) {
                        scrolloffset = 0;
                      }
                      jQuery('html, body').animate({
                        scrollTop: scrolloffset,
                      }, 500, function() {
                          // Callback after animation
                          // Must change focus!
                          var $target = jQuery(target);

                          $target.focus();

                          if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                          } else {
                              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                              $target.focus(); // Set focus again
                            }
                          });
                    }
                  }
                });

         new WOW().init();

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    // About us page, note the change from about-us to about_us.
    'single_location': {
      init: function() {
        // JavaScript to be fired on the about us page

        fireCalendar();

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS



        function checkLabel(element) {
          var parentLabel = jQuery(element).parent();
          if (parentLabel.hasClass('active')) {
            parentLabel.removeClass('active');
          } else {
            parentLabel.addClass('active');
          }
        }







      }
    },
    // About us page, note the change from about-us to about_us.
    'post_type_archive_ht_kb': {
      init: function() {
          // JavaScript to be fired on the about us page

          jQuery(function() {
            jQuery('.hkb-subcats__cat-title').matchHeight({
              byRow: false
            });
          });

        }
      }
    };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.






function checkLabel(element) {
  var parentLabel = jQuery(element).parent();
  if (jQuery(element).is(':checked')) {
    parentLabel.removeClass('active');
    parentLabel.addClass('active');
  } else {
    parentLabel.removeClass('active');
  }
}

function fireFormFunctions() {
  jQuery('input[type="checkbox"]').each(function() {
    checkLabel(jQuery(this));
  });
  jQuery('input[type="checkbox"]').change(function() {
    checkLabel(jQuery(this));
  });
}

setTimeout(function(){
  fireFormFunctions();
}, 1000);
